import React, { useState, useEffect } from "react";
import { Tabs, message } from "antd";

import { RecLimitedApiService } from "../ApiService/RecApiService";
import RecHeader from "./RecHeader";
import RecRegistrationForm from "./RecRegistrationForm";
import RecPrePayment from "./RecPrePayment";
import RecReceipts from "./RecReceipts";


import "../styles/index.css";


const RecBondPage = () => {
  const [messageApi, contextHolder] = message.useMessage();

  const [activeTab, setActiveTab] = useState("bonds");

  const [step, setStep] = useState("registration");

  const [loading, setLoading] = useState(false);

  const [paymentDetails, setPaymentDetails] = useState({});

  const [formData, setFormData] = useState({
    full_name: "",
    mobile_number: "",
    email: "",
    pan: "",
    amount: null,
    consent: false,
  });

  useEffect(() => {
    document.title = "REC Limited";
  }, []);

  /**
   * Registration Form Submit
   */
  const handleRegistrationSubmit = async (values) => {
  try {
    const response = await RecLimitedApiService.generateApplicationId({
      full_name: values.full_name,
      email: values.email,
      mobile_number: values.mobile,
      amount: values.amount,
      pan: values.pan,
      consent: values.consent,
    });

    if (!response?.success) {
      messageApi.error(
        response?.data?.message || "Unable to generate application ID."
      );
      return;
    }

    setPaymentDetails({ ...response, full_name: values.full_name, email: values.email, mobile_number: values.mobile, pan: values.pan });
    setStep("pre-payment");
  } catch (error) {
    messageApi.error("Unable to continue.");
  }
};

  /**
   * Back button from pre-payment page
   */
  const handleBackToForm = () => {
    setStep("registration");
  };

  /**
   * Payment click
   * Backend integration later
   */
  const handlePayment = async () => {
  try {
    setLoading(true);

    const response = await RecLimitedApiService.initiatePayment({
      application_id: paymentDetails.application_id,
      full_name: paymentDetails.full_name,
      email: paymentDetails.email,
      mobile_number: paymentDetails.mobile_number,
      amount: paymentDetails.amount,
      pan: paymentDetails.pan,
    });

    setLoading(false);

    if (!response?.status) {
      messageApi.error(
        response?.message ||
          response?.data?.message ||
          "Unable to initiate payment."
      );
      return;
    }

    // Redirect user to Easebuzz hosted payment page
    window.location.href = response.data.payment_url;

  } catch (error) {
    setLoading(false);
    messageApi.error("Unable to initiate payment.");
  }
};

  const renderBondJourney = () => {
    if (step === "registration") {
      return (
        <RecRegistrationForm
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleRegistrationSubmit}
        />
      );
    }

    return (
      <RecPrePayment
        paymentDetails={paymentDetails}
        loading={loading}
        onBack={handleBackToForm}
        onPay={handlePayment}
      />
    );
  };

  return (
    <>
      {contextHolder}

      <div className="rec-page-container">
        <RecHeader />

        <div className="rec-content-wrapper"> <Tabs centered activeKey={activeTab} onChange={setActiveTab} className="rec-tabs" items={[ { key: "bonds", label: "REC CGTE Bonds", }, { key: "receipts", label: "Payment Receipts", }, ]} /> <div className="rec-main-card"> {activeTab === "bonds" ? ( renderBondJourney() ) : ( <RecReceipts /> )} </div> </div>

        <div className="rec-footer">
          <div>
            © Copyright 2026 | Easebuzz Private Limited, All Rights Reserved.
          </div>

          <div className="rec-footer-links">
            <a href="https://easebuzz.in/terms/?srsltid=AfmBOoogK4xHTALCPPJDRJBiZjJ-pqQoQ0bRqjSRF0VLEpaC0nDcrwvs">
              Terms & Conditions
            </a>

            <a href="https://easebuzz.in/privacy/?srsltid=AfmBOoop-9ItOcCebxHFpceEo2el_tEOQYW5zCb5coV4xSiZInbVAmD5">
              Privacy Policy
            </a>

            <a href="https://easebuzz.in/cancellations/?srsltid=AfmBOoqw6rhzbx_mWkMMnzq0P7cQ1o6UxM_bcuP8QMIB9u13HyOcM9Pz">
              Cancellation & Refund Policy
            </a>
          </div>

          <div>
            Tech Support Email :
            {" "}
            support@easebuzz.in
          </div>
        </div>
      </div>
    </>
  );
};

export default RecBondPage;